import global from "@/locales/bs-BA/global";
import error403 from "@/locales/bs-BA/errors/403";
import error404 from "@/locales/bs-BA/errors/404";
import error500 from "@/locales/bs-BA/errors/500";
import error503 from "@/locales/bs-BA/errors/503";
import error504 from "@/locales/bs-BA/errors/504";
import maintenance from "@/locales/bs-BA/auth/maintenance";
import toast from "@/locales/bs-BA/toast/toast";
import login from "@/locales/bs-BA/auth/login";
import onboarding from "@/locales/bs-BA/auth/onboarding";
import loginPageSteps from "@/locales/bs-BA/loginPageSteps";
import dashboard from "@/locales/bs-BA/dashboard/dashboard";
import account from "@/locales/bs-BA/account/account";
import mailbox from "@/locales/bs-BA/account/mailbox";
import bankstatement from "@/locales/bs-BA/account/bankstatement";
import myApps from "@/locales/bs-BA/my-apps/myApps";
import about from "@/locales/bs-BA/about/about";
import contactService from "@/locales/bs-BA/about/contactService";
import salesPromotions from "@/locales/bs-BA/sales/promotions";
import brochures from "@/locales/bs-BA/sales/brochures";
import shop from "@/locales/bs-BA/shop/data";
import priceList from "@/locales/bs-BA/shop/priceList";
import staff from "@/locales/bs-BA/dashboard/staff";
import promotions from "@/locales/bs-BA/promotions";
import points from "@/locales/bs-BA/points";
import trainings from "@/locales/bs-BA/trainings/trainings";
import vouchers from "@/locales/bs-BA/vouchers/vouchers";
import media from "@/locales/bs-BA/media/index";
import product from "@/locales/bs-BA/product/index";
import message from "@/locales/bs-BA/message/index";
import commitmentLetter from "@/locales/bs-BA/account/commitmentLetter";
import multiplicator from "@/locales/bs-BA/multiplicator";
import consents from "@/locales/bs-BA/consents/consents";
import investment from "@/locales/bs-BA/investment/data";
import kickback from "@/locales/bs-BA/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Slike proizvoda",
    BDriveLinkText: "Link do portala SLIKA PROIZVODA",
  },
}

export default {
  locale: "bs-BA",
  messages,
};
